export class PagedData<T> {
  content: Array<T> = [];
  totalPages = 0;
  totalElements = 0;
  number = 0;
  size?: number;
  first?: boolean;
  last?: boolean;
}
